export function unitSelection(target, cofactorLinkAnalyte, tenantAnalyteList, allUnits, allUnitGroups, cofactorList, Id) {
  if (target && !!target.AnalyteId) {
    let unitList = []
    let targetCoFactor = cofactorLinkAnalyte.find(x => x.CoFactorId == Id)
    let targetAnalyte = tenantAnalyteList.find(x => x.Id == targetCoFactor.AnalyteId)
    let targetUnit = allUnits.find(x => x.Id == targetAnalyte.DefaultUnitId)
    targetUnit.Groups.map(x => {
      let targetUnitGroup = allUnitGroups.find(y => y.Id == x.Id)
      targetUnitGroup.Units.forEach(z => unitList.push(z))
    })
    return unitList
  } else {
    let unitList = []
    let targetCoFactor = cofactorList.find(x => x.Id == Id)
    targetCoFactor.UnitGroups.forEach(x => {
      allUnitGroups.forEach(y => {
        if (y.Id == x.Id) {
          y.Units.forEach(z => unitList.push(z))
        }
      })
    })
    return unitList
  }
}
